const init = (draft, action) => {
    var _a;
    const { defaultState, filterConfig, initialFilters, name, reinitialize } = action.payload;
    const initialFilterKeys = Object.keys(initialFilters);
    const hasInitialFilters = !!Object.keys(initialFilters).length;
    const defaultStateDisplayedFilters = defaultState === null || defaultState === void 0 ? void 0 : defaultState.displayedFilters;
    const displayedFilters = defaultStateDisplayedFilters ? [...defaultStateDisplayedFilters] : [];
    const filters = {};
    if (((_a = draft[name]) === null || _a === void 0 ? void 0 : _a.initialized) && !reinitialize && !hasInitialFilters)
        return;
    filterConfig.forEach((filter) => {
        var _a, _b;
        const { name, required, defaultValues } = filter;
        if (hasInitialFilters) {
            // When the filters are already initialized
            if (initialFilterKeys.includes(name)) {
                pushUnique(displayedFilters, name);
                const filterValues = initialFilters[name];
                filters[name] = Array.isArray(filterValues) ? Array.from(new Set(filterValues)) : filterValues;
            }
            else if (required) {
                pushUnique(displayedFilters, name);
                filters[name] = defaultValues;
            }
            else {
                if (filter.static)
                    pushUnique(displayedFilters, name);
            }
        }
        else {
            // When the filters are not initialized
            if ((_a = defaultState === null || defaultState === void 0 ? void 0 : defaultState.filters) === null || _a === void 0 ? void 0 : _a[name]) {
                // when the filter is added in the default state already
                filters[name] = (_b = defaultState === null || defaultState === void 0 ? void 0 : defaultState.filters) === null || _b === void 0 ? void 0 : _b[name];
                pushUnique(displayedFilters, name);
            }
            else {
                // when the filter is NOT in the default state, we check for if
                // required or static boolean params are set to true and then set them
                // in the default list of displayed filters
                if (filter.static === true || required === true) {
                    pushUnique(displayedFilters, name);
                    filters[name] = defaultValues;
                }
            }
        }
    });
    draft[name] = {
        config: filterConfig,
        displayedFilters,
        defaultFilters: JSON.parse(JSON.stringify(displayedFilters)),
        filters,
        initialized: true,
        cache: new Map()
    };
};
const pushUnique = (arr, item) => {
    if (arr.includes(item))
        return;
    arr.push(item);
};

export { init };
//# sourceMappingURL=init.esm.js.map
